/**
 * SupportFAB - Floating Action Button for Support AI
 * Global bottom-right button that opens the Support Drawer
 */

import React, { useState } from 'react';
import { MessageCircleQuestion, X } from 'lucide-react';
import { useSupportContext } from '../context/SupportContext';
import { useProductMode } from '../context/ProductModeContext';
import { trackAssistantOpen } from '../utils/telemetry';

const SupportFAB = () => {
  const { openSupportDrawer, isDrawerOpen } = useSupportContext();
  const { productMode } = useProductMode();
  const [isHovered, setIsHovered] = useState(false);
  
  // Don't show FAB when drawer is open
  if (isDrawerOpen) return null;
  
  const handleClick = () => {
    trackAssistantOpen('fab', productMode);
    openSupportDrawer();
  };
  
  return (
    <div className="fixed bottom-6 right-6 z-30">
      {/* Tooltip */}
      {isHovered && (
        <div className="absolute bottom-full right-0 mb-2 px-3 py-1.5 bg-gray-900 text-white text-xs rounded-lg whitespace-nowrap shadow-lg">
          Ask Support AI
          <div className="absolute bottom-0 right-4 transform translate-y-1/2 rotate-45 w-2 h-2 bg-gray-900" />
        </div>
      )}
      
      {/* FAB Button */}
      <button
        onClick={handleClick}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        className="w-14 h-14 rounded-full bg-gradient-to-br from-purple-600 to-blue-600 text-white shadow-lg hover:shadow-xl hover:scale-105 transition-all flex items-center justify-center"
        data-testid="support-fab"
        aria-label="Open Support AI"
      >
        <MessageCircleQuestion className="w-6 h-6" />
      </button>
    </div>
  );
};

export default SupportFAB;
